/**
 * @prettier
 * @author Alexander Nagelberg
 */
import React from 'react'
import { Field, reduxForm } from 'redux-form'

import LgyInputField from 'app/components/util/lgy-input-field/LgyInputField'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import LgyTextArea from 'app/components/util/lgy-text-area/LgyTextArea'

// This will wrap an existing field component and pass disabled to the input
const DisableableInput = ({ disabled, inputComponent, input, ...props }) =>
  React.createElement(inputComponent, { ...props, input: { ...input, disabled } })

const RefundNoteForm = ({ isNew, isAffiliate, handleSubmit, ...props }) => (
  <div className='lgy-funding-fee-note-form'>
    <form autoComplete='off' className='usa-form' onSubmit={handleSubmit}>
      {!isNew && (
        <Field
          component={DisableableInput}
          inputComponent={LgyInputField}
          label='Author'
          name='author'
          disabled
          required
        />
      )}
      <Field
        component={DisableableInput}
        inputComponent={LgyInputField}
        label='Title'
        name='title'
        disabled={!isNew}
        required
      />
      <Field
        component={DisableableInput}
        inputComponent={LgyTextArea}
        label='Note'
        name='body'
        disabled={!isNew}
        required
      />
      {isNew && <LgyFormSubmit {...props} />}
    </form>
  </div>
)

export default reduxForm({})(RefundNoteForm)
